import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';

export function ProtectedRoute() {
  const { user, authReady, isPasswordRecovery } = useAuth();

  // Wait for auth to be fully initialized (including OAuth callback processing)
  if (!authReady) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If user is in password recovery mode, redirect to reset password page
  if (isPasswordRecovery) {
    return <Navigate to="/reset-password" replace />;
  }

  return <Outlet />;
}

export function PublicOnlyRoute() {
  const { user, authReady, isPasswordRecovery } = useAuth();

  // Wait for auth to be fully initialized (including OAuth callback processing)
  if (!authReady) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // If user is logged in (and not in password recovery), redirect to dashboard
  if (user && !isPasswordRecovery) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}